'use client';
import { jsx } from 'react/jsx-runtime';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

const SelectionSetTileImageContainer = renderWithRef('SelectionSetTileImageContainer', null, (t, r)=>jsx(RenderComp, {
        root: "div",
        forwardedRef: r,
        classNames: [
            'swan-selection-set-tile-image-container'
        ],
        props: t,
        children: t.children
    }));

export { SelectionSetTileImageContainer };
